export default __webpack_public_path__ + "static/media/lighting.f573714d.svg";